package ru.villawonka.app.presentation.screens.search.model

import ru.villawonka.app.domain.model.SortTypeDomain
import ru.villawonka.app.presentation.screens.variantPicker.model.VariantPickerItemUIModel
import ru.villawonka.app.resources.AppResources

interface SortTypeUIModel {
    val text: String

    class Newest : SortTypeUIModel {
        override val text: String
            get() = AppResources.strings.sortTypeNewest
    }

    class HighPrice : SortTypeUIModel {
        override val text: String
            get() = AppResources.strings.sortTypeHighPrice
    }

    class LowPrice : SortTypeUIModel {
        override val text: String
            get() = AppResources.strings.sortTypeLowPrice
    }
}

fun SortTypeDomain.toUIModel() =
    when (this) {
        SortTypeDomain.NEWEST -> SortTypeUIModel.Newest()
        SortTypeDomain.HIGH_PRICE -> SortTypeUIModel.HighPrice()
        SortTypeDomain.LOW_PRICE -> SortTypeUIModel.LowPrice()
    }

fun SortTypeUIModel.toDomainModel() =
    when (this) {
        is SortTypeUIModel.Newest -> SortTypeDomain.NEWEST
        is SortTypeUIModel.HighPrice -> SortTypeDomain.HIGH_PRICE
        is SortTypeUIModel.LowPrice -> SortTypeDomain.LOW_PRICE
        else -> throw Exception("")
    }

fun SortTypeUIModel.toVariantPickerItemUIModel() = VariantPickerItemUIModel(
    title = text,
)

fun VariantPickerItemUIModel.toSortTypeUIModel(): SortTypeUIModel? =
    when (title) {
        AppResources.strings.sortTypeNewest -> SortTypeUIModel.Newest()
        AppResources.strings.sortTypeHighPrice -> SortTypeUIModel.HighPrice()
        AppResources.strings.sortTypeLowPrice -> SortTypeUIModel.LowPrice()
        else -> null
    }